/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Adminsubs_Adjustdesc2Inputs */

const zh_adminsubs_adjustdesc2 = /** @type {(inputs: Adminsubs_Adjustdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为用户增加或减少点数`)
};

const en_adminsubs_adjustdesc2 = /** @type {(inputs: Adminsubs_Adjustdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add or subtract credits for this user`)
};

const es_adminsubs_adjustdesc2 = /** @type {(inputs: Adminsubs_Adjustdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agregar o restar créditos para este usuario`)
};

/**
* | output |
* | --- |
* | "Add or subtract credits for this user" |
*
* @param {Adminsubs_Adjustdesc2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const adminsubs_adjustdesc2 = /** @type {((inputs?: Adminsubs_Adjustdesc2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adminsubs_Adjustdesc2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_adminsubs_adjustdesc2(inputs)
	if (locale === "en") return en_adminsubs_adjustdesc2(inputs)
	return es_adminsubs_adjustdesc2(inputs)
});
export { adminsubs_adjustdesc2 as "adminSubs_adjustDesc" }